import { j as e } from "./AccesRecoveryIcon-CUPieIxT.js";
const o = () => /* @__PURE__ */ e.jsxs("svg", { viewBox: "0 0 75 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ e.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55 40c-11.046 0-20-8.954-20-20S43.954 0 55 0s20 8.954 20 20-8.954 20-20 20m2.403-22.759v-2.957h6.767v-4.51H45.744v4.51h6.767v2.956c-5.5.253-9.636 1.343-9.636 2.648 0 1.304 4.136 2.393 9.636 2.647v9.478h4.892v-9.48c5.49-.253 9.617-1.342 9.617-2.646s-4.126-2.392-9.617-2.646m0 4.488v-.003c-.138.01-.847.053-2.428.053a52 52 0 0 1-2.464-.053v.004c-4.86-.214-8.487-1.06-8.487-2.073s3.627-1.857 8.487-2.075v3.305a37 37 0 0 0 2.485.077c1.509 0 2.265-.063 2.407-.075v-3.304c4.85.216 8.468 1.063 8.468 2.072 0 1.013-3.618 1.857-8.468 2.072",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20m.41-36.833 4.14 21.293 10.337 3.75zm-.937.667L5 28.917h.012L21.53 14.439zM34.97 29.208l-20.46-7.416-8.498 7.416 28.958-.001z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e.jsx("rect", { x: "36.25", y: "1.25", width: "37.5", height: "37.5", rx: "18.75", stroke: "currentColor", strokeWidth: "2.5" })
] });
export {
  o as U
};
